export interface Column {
  name: string;
  type?: 'input' | 'select' | 'number' | 'create-demand-files' | 'sections';
  placeHolder?: string;
  key?: string;
  values?: string[];
  width?: string;
  color?: string;
  fontFamily?: string;
  image?: any;
  wrapperFn?: any;
  sortable?: boolean;
  data?: any;
  sortMethod?: <T extends Record<any, string>>(
    data: T[],
    direction: SortDirection,
    key?: keyof T
  ) => void;
}

export enum SortDirection {
  Ascending = 'ascending',
  Descending = 'descending',
}
